export default "__VITE_PUBLIC_ASSET__39b5f9f6__"